export const SET_BETTING_CLOSED = 'SET_BETTING_CLOSED'
export const SET_NEXT_DRAW_ID = 'START_NEXT_DRAW'
export const SET_NEXT_DRAW_TIMESTAMP = 'SET_NEXT_DRAW_TIMESTAMP'
export const SET_PREVIOUS_DRAW = 'SET_PREVIOUS_DRAW'